<page-loading *ngIf="!initialized"></page-loading>

<operator-sidebar-panel *ngIf="isOperatorMode"
  [mpinfo]="marketPartnerInfo"
  [upinfo]="companyPartnerInfo"
  [activeViewMode]="'notifications'"></operator-sidebar-panel>
<div *ngIf="initialized" id="page-content"
  [class.page-content-with-sidebar]="isOperatorMode"
>
  <div class="row">
    <div class="col-sm-12">
      <div class="tab-base  no-botton-margin-margin">

        <div style="display: flex; flex-direction: row; align-items: flex-start; margin-top: 12px; margin-bottom: 8px;">
          <div id="dropdown-create" class="dropdown app-dropdown" *ngIf="!isOperatorMode">
            <button class="btn-labeled btn table-action-button btn-danger" data-toggle="dropdown">
              <i class="pli-trash"></i>
              <span class="button-text">{{'DeleteNotificationsCreateDropdown' | translate}}</span>
              <i class="dropdown-caret"></i>
            </button>
            <ul class="dropdown-menu">
              <li *ngFor="let button of createButtons">
                <a (click)="button.fnClicked()" class="btn-a">{{button.label | translate}}</a>
              </li>
            </ul>
          </div>

          <button *ngIf="partnerId === 0 || isOperatorMode" class="btn-labeled btn table-action-button btn-mint" (click)="handleResendLast24Hours()">
            <i class="pli-repeat-2" style="margin-right: 4px;"></i>
            <span class="button-text">{{'ActionNotificationResendLast24Hours' | translate}}</span>
          </button>
        </div>

        <!--Nav tabs-->
        <!--Tabs Content-->
        <div class="tab-content">
          <div class="tab-pane fade active in">
            <smart-table #tableNotificationsOwned
              [tableConfig]="tableNotifications"
              (onRowClicked)="onRowClicked($event)"
              (onActionClicked)="onActionPerformed($event)"
            ></smart-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
